// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// ----------------- Nur für Beschwerdemanagement RD ECK ---------------------
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Drawer from 'rc-drawer';
import './drawer.css';
import { setNewIssueDrawerState, setNewIssuePropValue, resetNewIssue, sendNewIssue } from 'actions/NewIssue';
import { Card, CardBody, CardHeader, Nav, NavItem, NavLink, TabContent, TabPane, Button, ListGroup, ListGroupItem } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import CardBox from 'components/CardBox/index';
import { injectIntl, intlShape } from 'react-intl';
import Dropzone from 'react-dropzone';
import InputSize from 'constants/InputSize';
import swal from 'sweetalert';
import _ from 'lodash';
import ModulesContainer from 'containers/ModulesContainer';
import { strPreview, byteStr } from 'helperfunctions';
import isIssue from 'helperfunctions/isIssue';

class NewIssue extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeTab: this.props.selectedTab || 'address', // 'address' oder 'map'
			responsibleInvalid: false,
			supTypeInvalid: false,
			typeInvalid: false
		};
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.newIssue.showFeedback && this.props.newIssue.showFeedback)
			swal({
				title: this.props.intl.formatMessage({ id: 'newReport.send.success' }),
				text: this.props.intl.formatMessage({ id: 'newReport.send.feedback' }, { responsible: this.props.newIssue.feedbackResponsible }),
				icon: 'success'
			});
	}

	handleFileDrop = file => {
		// Es können maximal 10 Dateien angehängt werden
		if (this.props.newIssue.attachements.length > 9)
			return swal({
				title: this.props.intl.formatMessage({ id: 'newReport.attachements.error.title' }),
				text: this.props.intl.formatMessage({ id: 'newReport.attachements.error.text' }),
				dangerMode: true,
				icon: 'warning'
			});

		// Ausgewählte Datei auf Maximalgröße von 16 MB prüfen
		if (file.size > 16777215) {
			return swal({
				title: this.props.intl.formatMessage({ id: 'report.userComments.inputSizeError.title' }),
				text: this.props.intl.formatMessage({ id: 'report.userComments.inputSizeError.text' }),
				dangerMode: true,
				icon: 'warning'
			});
		}

		this.props.setNewIssuePropValue({
			attachements: [...this.props.newIssue.attachements, { file, fileName: file.name, fileType: file.type }]
		});
	};

	toggle = tab => {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	};

	sendNewIssue = async () => {
		const { typeId, responsibleId, supTypeId } = this.props.newIssue;

		// Anforderungen prüfen (Responsible, SupType, Type)

		if (!responsibleId) this.setState({ responsibleInvalid: true });
		if (!supTypeId) this.setState({ supTypeInvalid: true });
		if (!typeId) this.setState({ typeInvalid: true });

		if (!responsibleId || !supTypeId || !typeId) return;

		this.props.sendNewIssue(this.props.newIssue);
	};

	getTypes = supTypeId => {
		switch (supTypeId) {
			case 1:
				return [{ id: 1, name: 'a' }];
			case 2:
				return [{ id: 2, name: 'b' }];
			case 3:
				return [{ id: 3, name: 'c' }];
			case 4:
				return [{ id: 4, name: 'd' }];
			default:
				return [];
		}
	};

	renderSidebar() {
		const {
			firstName,
			lastName,
			phone,
			email,
			typeId,
			description,
			title,
			responsibleId,
			userComment,
			attachements,
			responseType,
			zip,
			city,
			street,
			houseNumber,
			supTypeId
		} = this.props.newIssue;
		const { setNewIssuePropValue, resetNewIssue, types } = this.props;
		return (
			<div
				className="app-wrapper"
				style={{
					backgroundColor: '#f4f4f4',
					maxHeight: '100vh',
					overflowY: 'scroll'
				}}
			>
				<div className="d-flex">
					<h2 className="title mb-3">Neues Anliegen erstellen</h2>
					<Button color="default" className="jr-flat-btn jr-btn ml-auto my-0 px-0" onClick={() => this.props.setNewIssueDrawerState(false)}>
						<i className="zmdi zmdi-close zmdi-hc-lg" />
						<IntlMessages id="common.close" />
					</Button>
				</div>

				<div className="row">
					<div className="col-lg-6 col-md-12">
						<CardBox heading="Wer meldet?" headerOutside styleName="col-12 p-0">
							<div className="row">
								<div className="col-sm-6 col-12">
									<div className="form-group">
										<label>
											<IntlMessages id="newReport.citizen.name" />
										</label>
										<input
											className="form-control form-control-lg"
											value={firstName}
											onChange={m =>
												setNewIssuePropValue({
													firstName: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'newReport.citizen.firstName'
											})}
											maxLength={InputSize.userFirstName}
										/>
									</div>
								</div>

								<div className="col-sm-6 col-12">
									<div className="form-group">
										<label>&nbsp;</label>
										<input
											className="form-control form-control-lg"
											value={lastName}
											onChange={m =>
												setNewIssuePropValue({
													lastName: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'newReport.citizen.lastName'
											})}
											maxLength={InputSize.userLastName}
										/>
									</div>
								</div>

								<div className="col-sm-6 col-12">
									<div className="form-group">
										<label>
											<IntlMessages id="newReport.citizen.email" />
										</label>
										<input
											className="form-control form-control-lg"
											value={email}
											onChange={m =>
												setNewIssuePropValue({
													email: m.target.value
												})
											}
											type="email"
											placeholder={this.props.intl.formatMessage({
												id: 'newReport.citizen.email'
											})}
											maxLength={InputSize.userEmail}
										/>
									</div>
								</div>

								<div className="col-sm-6 col-12">
									<div className="form-group">
										<label>
											<IntlMessages id="newReport.citizen.phone" />
										</label>
										<input
											className="form-control form-control-lg"
											value={phone}
											onChange={m =>
												setNewIssuePropValue({
													phone: m.target.value
												})
											}
											type="tel"
											placeholder={this.props.intl.formatMessage({
												id: 'newReport.citizen.phone'
											})}
											maxLength={InputSize.userPhone}
										/>
									</div>
								</div>

								<div className="col-md-4 col-12">
									<div className="form-group">
										<label form="zip">
											<IntlMessages id="organisationProfile.props.address" />
										</label>
										<input
											className="form-control form-control-lg"
											id="zip"
											value={zip}
											onChange={m =>
												setNewIssuePropValue({
													zip: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'report.props.address.zip'
											})}
											maxLength={InputSize.addressZip}
										/>
									</div>
								</div>
								<div className="col-md-8 col-12">
									<div className="form-group">
										<label htmlFor="city">&nbsp;</label>
										<input
											className="form-control form-control-lg"
											value={city}
											onChange={m =>
												setNewIssuePropValue({
													city: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'report.props.address.city'
											})}
											maxLength={InputSize.addressCity}
										/>
									</div>
								</div>
								<div className="col-md-8 col-12">
									<div className="form-group">
										<input
											className="form-control form-control-lg"
											value={street}
											onChange={m =>
												setNewIssuePropValue({
													street: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'report.props.address.street'
											})}
											maxLength={InputSize.addressStreet}
										/>
									</div>
								</div>

								<div className="col-md-4 col-12">
									<div className="form-group">
										<input
											className="form-control form-control-lg"
											value={houseNumber}
											onChange={m =>
												setNewIssuePropValue({
													houseNumber: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'common.houseNumber'
											})}
											maxLength={InputSize.addressHouseNumber}
										/>
									</div>
								</div>
								<div className="col-12">
									<div className="form-group">
										<label>Eine Antwort erbitte ich via...</label>
										<select
											className="custom-select mr-2 my-1 w-100"
											onChange={m =>
												setNewIssuePropValue({
													responseType: parseInt(m.target.value)
												})
											}
											value={responseType}
										>
											<option value={1}>Email</option>
											<option value={2}>Brief</option>
											<option value={3}>Anruf</option>
											<option value={4}>keine Rückmeldung erforderlich</option>
										</select>
									</div>
								</div>
							</div>
						</CardBox>
					</div>

					<div className="col-lg-6 col-md-12">
						<CardBox heading="Was wird gemeldet?" headerOutside styleName="col-12 p-0">
							<div className="row">
								<div className="col-md-6 col-sm-12">
									<div className="form-group">
										<label>
											<strong>
												<IntlMessages id="report.props.responsible" /> (<IntlMessages id="common.mandatory" />)
											</strong>
										</label>
										<select
											className={`custom-select mr-2 my-1 w-100${this.state.responsibleInvalid ? ' is-invalid' : ''}`}
											onChange={m => {
												setNewIssuePropValue({
													responsibleId: parseInt(m.target.value)
												});
												this.setState({ responsibleInvalid: false });
											}}
											value={responsibleId}
										>
											<option value={0}>Wählen Sie eine Zuständigkeit</option>
											{this.props.responsibles.map(r => (
												<option key={r.responsibleId} value={r.responsibleId}>
													{r.name}
												</option>
											))}
										</select>
									</div>
									<div className="form-group">
										<label>
											<strong>
												Art (<IntlMessages id="common.mandatory" />)
											</strong>
										</label>
										<select
											className={`custom-select mr-2 my-1 w-100${this.state.supTypeInvalid ? ' is-invalid' : ''}`}
											onChange={m => {
												setNewIssuePropValue({
													supTypeId: parseInt(m.target.value),
													typeId: 0
												});
												this.setState({ supTypeInvalid: false, typeInvalid: false });
											}}
											value={supTypeId}
										>
											<option value={0}>Art wählen</option>
											<option value={1}>Beschwerde</option>
											<option value={2}>Anregung</option>
											<option value={3}>Dank/Lob</option>
											<option value={4}>Sonstiger Hinweis</option>
										</select>
									</div>
									<div className="form-group">
										<label>
											<strong>
												<IntlMessages id="newReport.type.title" /> (<IntlMessages id="common.mandatory" />)
											</strong>
										</label>
										<select
											className={`custom-select mr-2 my-1 w-100${this.state.typeInvalid ? ' is-invalid' : ''}`}
											onChange={m => {
												setNewIssuePropValue({
													typeId: parseInt(m.target.value)
												});
												this.setState({ typeInvalid: false });
											}}
											value={typeId}
										>
											<option value={0}>
												{this.props.intl.formatMessage({
													id: 'newReport.type.placeholder'
												})}
											</option>
											{types.map(type => (
												<option key={type.id} value={type.id}>
													{type.name}
												</option>
											))}
										</select>
									</div>
								</div>
								<div className="col-md-6 col-sm-12">
									<div className="form-group">
										<label>
											<IntlMessages id="report.props.title" />
										</label>
										<input
											className="form-control form-control-lg"
											value={title}
											onChange={m =>
												setNewIssuePropValue({
													title: m.target.value
												})
											}
											type="text"
											placeholder={this.props.intl.formatMessage({
												id: 'report.props.title'
											})}
											maxLength={InputSize.reportTitle}
										/>
									</div>
									<div className="form-group">
										<label>
											<IntlMessages id="newReport.description" />
										</label>
										<textarea
											className="form-control form-control-lg my-3"
											rows="5"
											placeholder={this.props.intl.formatMessage({
												id: 'newReport.description'
											})}
											onChange={m =>
												setNewIssuePropValue({
													description: m.target.value
												})
											}
											value={description}
											maxLength={InputSize.reportDescription}
										/>
									</div>
								</div>
								<div className="col-12">
									<h4>Anlagen</h4>
								</div>
								<div className="col-md-6 col-sm-12">
									<div className="w-100">
										<h4>{this.props.intl.formatMessage({ id: 'newReport.attachements.comment' })}</h4>
										<div className="form-group my-0">
											<textarea
												maxLength={1000}
												className="form-control form-control-lg my-0"
												rows="8"
												placeholder="Schreiben Sie einen Kommentar"
												onChange={m =>
													setNewIssuePropValue({
														userComment: m.target.value
													})
												}
												value={userComment}
											/>
										</div>
									</div>
								</div>

								<div className="col-md-6 col-sm-12">
									<div className="w-100">
										<h4>{this.props.intl.formatMessage({ id: 'newReport.attachements.files' })}</h4>
										<div className="dropzone">
											<Dropzone
												ref={node => {
													this.attachementsRef = node;
												}}
												onDrop={(accepted, rejected) => (accepted && accepted[0] ? this.handleFileDrop(accepted[0]) : null)}
												multiple={false}
												disableClick={true}
											>
												<div
													className="w-100 h-100 d-flex align-items-center flex-column"
													style={{
														justifyContent: 'space-evenly'
													}}
												>
													<i
														className="zmdi zmdi-file-plus zmdi-hc"
														style={{
															fontSize: '5em'
														}}
													/>
													<p className="pt-2 text-center">Ziehen Sie einen Anhang hier hin</p>
												</div>
											</Dropzone>
											<p className="text-muted text-center m-2">
												<IntlMessages id="common.or" />
											</p>
											<div className="d-flex flex-direction-column align-items-center px-3 py-0">
												<Button
													color="default"
													className="jr-btn btn-blue btn border-0 mt-0 mb-2 mx-0 text-capatalize"
													onClick={() => {
														this.attachementsRef.open();
													}}
													style={{ width: 200, textTransform: 'none' }}
												>
													Wählen Sie eine Datei
												</Button>
											</div>
										</div>
										<ListGroup>
											{attachements.map((a, i) => (
												<ListGroupItem key={i} action className="d-flex align-items-center list-group-item">
													<span className="text-dark">{`${a.fileName} (${byteStr(a.file.size)})`}</span>
													<span
														className="ml-auto pointer"
														style={{ width: 10 }}
														onClick={() =>
															setNewIssuePropValue({
																attachements: attachements.filter((element, index) => index !== i)
															})
														}
													>
														<i className="zmdi zmdi-hc-lg zmdi-close ml-auto text-dark" />
													</span>
												</ListGroupItem>
											))}
										</ListGroup>
									</div>
								</div>
							</div>
						</CardBox>
					</div>
					<div className="col-12 d-flex">
						<Button
							color="default"
							className="jr-btn btn-blue btn border-0 mt-0 mb-2"
							onClick={this.sendNewIssue}
							disabled={this.props.loading.sendNewIssue}
						>
							{this.props.loading.sendNewIssue ? (
								<i className="zmdi zmdi-spinner zmdi-hc-spin" />
							) : (
								<IntlMessages id="newReport.send" />
							)}
						</Button>
						<Button color="default" className="jr-btn btn-grey btn border-0 mt-0 mb-2" onClick={resetNewIssue}>
							<IntlMessages id="newReport.reset" />
						</Button>
					</div>
				</div>
			</div>
		);
	}

	render() {
		const { setNewIssueDrawerState, showDrawer } = this.props;
		return (
			<div className="drawer-box">
				<Drawer
					sidebar={this.renderSidebar()}
					position="top"
					touch
					open={showDrawer}
					onOpenChange={() => setNewIssueDrawerState(!showDrawer)}
					style={{ overflow: 'auto' }}
				>
					<div />
				</Drawer>
			</div>
		);
	}
}

function mapStateToProps({ newIssue, accountSettings, auth }) {
	return {
		newIssue: newIssue.newIssue,
		showDrawer: newIssue.showDrawer,
		types: _.uniqBy(accountSettings.areaTypes, 'id').filter(e => isIssue(e.id)),
		organisationLatlng: accountSettings.organisationStructure.location.latlng,
		responsibilityAreas: accountSettings.organisationStructure.responsibilityAreas,
		responsibles: [
			...accountSettings.organisationStructure.groups.filter(group => group.modules.issues),
			...accountSettings.organisationStructure.users
				.filter(user => user.modules.issues)
				.map(u => {
					return { responsibleId: u.responsibleId, name: `${u.firstName} ${u.lastName}` };
				})
		],
		loading: newIssue.loading,
		authUser: auth.authUser,
		reportsDefaultInvisible: accountSettings.organisationStructure.reportsDefaultInvisible
	};
}

NewIssue.propTypes = {
	intl: intlShape
};

export default connect(
	mapStateToProps,
	{
		setNewIssueDrawerState,
		setNewIssuePropValue,
		resetNewIssue,
		sendNewIssue
	}
)(injectIntl(NewIssue));



// WEBPACK FOOTER //
// ./containers/NewIssue/index.js